import React from 'react'
import { Link } from 'react-router-dom'
import GalleryPhoto from './newhomepage/GallaryPhoto'

const Gallary = () => {
  return (
    <div className=' mt-10'>
        <div className='  '>
        <div className='flex lg:flex-row  flex-col  w-[100%] items-center gap-5 justify-between'>
        <div className='flex flex-col lg:w-[40%] w-[50%] mx-20'>
        <h1 className='text-richblack-600 lg:text-4xl text-[1.1rem]   font-bold mt-6 font-roboto'>Sumit Mehendi Art</h1>
        <div className='flex flex-row mt-2 lg:ml-10 gap-4 font-mono font-bold text-lg text-richblack-500 '>
        
        <Link to="/">
                <h1>Gallery</h1>
        </Link>|
        <Link to="/">
                <h1>Contact</h1>
        </Link>

        </div>
        
        </div>
        <div className='flex flex-col text-center lg:w-[40%] lg:mr-14 '>
        <p className='font-mono font-semibold text-richblack-600'>"Our team ensures a hygienic and comfortable environment, making your Mehandi experience enjoyable and relaxing."</p>

        </div>

        </div>
        <div className='cards'>
        <GalleryPhoto/>

        </div>

        </div>
    </div>
  )
}

export default Gallary